
import { FC } from 'react'; 
import { createPortal } from 'react-dom';

import ChatDialog from './ChatDialog/ChatDialog';


interface DraggableChatProps {
  open: boolean;
  onClose: () => void;
}

const DraggableChatContent: FC<DraggableChatProps> = ({ open, onClose }) => {
  
  return <ChatDialog open={open} onClose={onClose} />;
};

const DraggableChat: FC<DraggableChatProps> = (props) => {
  return createPortal(
      <DraggableChatContent {...props} />,
      document.body
  );
};

export default DraggableChat;